import { Routes, Route } from "react-router-dom";
import RegisterForm from "./components/auth/RegisterForm";
import RegisterStep2 from "./components/auth/RegisterStep2";
import RegisterStep3 from "./components/auth/RegisterStep3";
import RegisterStep4 from "./components/auth/RegisterStep4";
import RegisterStep5 from "./components/auth/RegisterStep5";
import RegisterStep6 from "./components/auth/RegisterStep6";
import StatsSection from "./components/static/StatsSection";
import AssistedService from "./components/static/AssistedService";
import Header from "./components/static/Header";
import LoginForm from "./components/auth/LoginForm";
import EliteMatrimony from "./components/static/EliteMatrimony";
import TestimonialSlider from "./components/static/TestimonialSlider";
import VerifyOTP from "./components/auth/VerifyOTP";
import ForgotPassword from "./components/auth/ForgotPassword";
import MembershipPricingPage from "./components/page/MembershipPricingPage";
import ProfileDrawer from "./components/page/ProfileSidebar ";
import UserPreferences from "./components/auth/UserPreferences";
import MatchesCarousel from "./components/page/MatchesCarousel";
import MatchesListPage from "./components/page/MatchesListPage";
import ProfileDetailPage from "./components/page/ProfileDetailPage";
import FilterPillBar from "./components/page/FilterPillBar";
import MatchesLayout from "./components/page/MatchesLayout";
import IgnoredProfilesListPage from "./components/page/IgnoredProfilesListPage";
import FavouriteProfilesListPage from "./components/page/FavouriteProfilesListPage";
import InterestsProfilesListPage from "./components/page/IntrestProfilesListPage";
// import Dashboard from "./components/Dashboard";
import { Toaster } from "react-hot-toast";
import ProfileViewsListPage from "./components/page/ProfileViewsListPage";
import ProfileSettingsPage from "./components/page/ProfileSettingsPage";
import BlockProfilesListPage from "./components/page/BlockProfilesListPage";
import ProfileLayout from "./components/page/ProfileLayout";
import MembershipCard from "./components/static/MembershipCard";
import Matcheslast30Days from "./components/page/Matcheslast30days";
import IgnoredProfilesCard from "./components/page/IgnoredProfilesCard";
import SuccessStoryForm from "./components/auth/SuccessStoryForm";
import SuccessStoriesSection from "./components/page/SuccessStoriesSection";
import SuccessStoriesPage from "./components/page/SuccessStoriesPage";
import MatrimonyFAQ from "./components/static/MatrimonyFAQ";
import Footer from "./components/static/Footer";
import WhatsAppFloatingButton from "./components/static/WhatsAppFloatingButton";
import ProfileEditPage from "./components/auth/ProfileEditPage/ProfileEditPage";
import NewMatch30Days from "./components/page/NewMatch30days";
import PrivateRoute from "./api/PrivateRoute";
// import App from './App';
import sword from "./assets/sword-icon.svg";
import palace from "./assets/palace-icon.svg";
import RajputHeroSection from "./components/static/RajputHeroSection";
import PrivacyPolicy from "./components/static/PrivacyPolicy";
import ContactUsForm from "./components/static/contactus";
import TermsAndConditions from "./components/static/termandcondition";
import BlogMessage from "./components/static/blogmessages";


import Dashboard from "./admin/dashboard";
import BlockedProfile from "./admin/blockedprofile";
import MembershipPlan from "./admin/membershipplan";
import MembershipPurchase from "./admin/membershippurchase";

import DeletedProfilesTable from "./admin/deleteprofile";
import SuccessStoryTable from "./admin/successstory";

import UploadBlogForm from "./admin/uploadblogform";
import BlogTable from "./admin/uploadblogtable";
import AddMembershipPlan from "./admin/addmembershipplan";
import AdminLayout from "./admin/AdminLayout";
import UserTable from "./admin/usertable";
import RequireAdminAuth from "./admin/RequireAdminAuth";
import AdminLoginForm from "./admin/loginpage";
import ContactUsTable from "./admin/contact_us";
import Lacks from "./components/static/Lacks";
import PromoPopup from "./components/PromoPopup";
import PromoPopupManager from "./admin/PromoPopupManager";





function HomePage() {
  return (
    <>


      <Header />
      <div>

        {/* Top Registration Form */}
        <RegisterForm />

        {/* Stats Section below */}
        <RajputHeroSection />
        <StatsSection />
        <AssistedService />
        <EliteMatrimony />
        <TestimonialSlider />
        <WhatsAppFloatingButton />
        {/* <BlogMessage /> */}
        <MatrimonyFAQ />
        <Footer />
        <PromoPopup />
      </div>
    </>
  );
}

function Contact() {

  return (
    <>
      <div className="w-full min-h-screen flex flex-col">
        {/* Hero Section */}
        <RajputHeroSection />

        {/* Contact Form Section (fills screen space if needed) */}
        <div className="flex-grow flex items-center justify-center bg-gray-50">
          <ContactUsForm />
        </div>

        {/* Footer */}
        <Footer />
      </div>
    </>
  );
}



function Userpage() {
  return (
    <>
      <Lacks />
      <div className="my-6 flex items-center justify-center">
        {/* <div className="flex items-center justify-center gap-2">
          <img src={sword} alt="sword" className="h-4 w-4" />
          <div className="h-1 w-1/3 bg-gradient-to-r from-[#800000] via-[#FFD700] to-[#800000] rounded-full shadow-md border border-yellow-300"></div>
          <img src={palace} alt="palace" className="h-4 w-4" />
        </div> */}
        <div className="h-px w-1/4 mobile-line bg-gradient-to-r from-pink-400 via-red-400 to-pink-400"></div>

        <span className="mx-3 text-gray-500 text-sm tracking-wider text-mobile">
          YOUR MATCH ARE HERE
        </span>
        <div className="h-px w-1/4 mobile-line bg-gradient-to-r from-pink-400 via-red-400 to-pink-400"></div>

      </div>
      <MatchesCarousel />


      {/* Decorative line with spacing */}

      <div className="my-6 flex items-center justify-center">
        <div className="h-px w-1/4 mobile-line bg-gradient-to-r from-pink-400 via-red-400 to-pink-400"></div>
        <span className="mx-3 text-[#800000] tracking-wide drop-shadow-md text-sm tracking-wider text-mobile">
          BE Jain Jivansathi FAMILY MEMBER
        </span>
        <div className="h-px w-1/4 mobile-line bg-gradient-to-r from-pink-400 via-red-400 to-pink-400"></div>
      </div>

      <MembershipCard />


      <div className="my-6 flex items-center justify-center">
        <div className="h-px w-1/4 mobile-line bg-gradient-to-r from-pink-400 via-red-400 to-pink-400"></div>
        <span className="mx-3 text-[#800000] tracking-wide drop-shadow-md text-sm tracking-wider text-mobile">
          FIND YOUR LATEST MATCH WITH Jain Jivansathi
        </span>
        <div className="h-px w-1/4 mobile-line bg-gradient-to-r from-pink-400 via-red-400 to-pink-400"></div>

      </div>
      <Matcheslast30Days />

      <div className="my-6 flex items-center justify-center">
        <div className="h-px w-1/4 mobile-line bg-gradient-to-r from-pink-400 via-red-400 to-pink-400"></div>
        <span className="mx-3 text-gray-500 text-sm tracking-wider text-mobile">
          FIND YOUR  MATCH 10x FASTER
        </span>
        <div className="h-px w-1/4 mobile-line bg-gradient-to-r from-pink-400 via-red-400 to-pink-400"></div>

      </div>
      <AssistedService />


      <div className="my-6 flex items-center justify-center">
        <div className="h-px w-1/4 mobile-line bg-gradient-to-r from-pink-400 via-red-400 to-pink-400"></div>
        <span className="mx-3 text-[#800000] tracking-wide drop-shadow-md text-sm tracking-wider text-mobile">
          Jain Jivansathi
        </span>
        <div className="h-px w-1/4 mobile-line bg-gradient-to-r from-pink-400 via-red-400 to-pink-400"></div>

      </div>
      <IgnoredProfilesCard />


      <div className="my-6 flex items-center justify-center">
        <div className="h-px w-1/4 mobile-line bg-gradient-to-r from-pink-400 via-red-400 to-pink-400"></div>
        <span className="mx-3 text-gray-500 text-sm tracking-wider text-mobile">
          FIND YOUR  MATCH 10x FASTER
        </span>
        <div className="h-px w-1/4 mobile-line bg-gradient-to-r from-pink-400 via-red-400 to-pink-400"></div>

      </div>
      <SuccessStoriesSection />

    </>
  );
}


function App() {
  return (
    <>

      <Toaster position="top-center" reverseOrder={false} />
      <Routes>


        <Route path="/" element={<HomePage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/termandcondition" element={<TermsAndConditions />} />
        <Route path="/blog-message" element={<BlogMessage />} />


        <Route path="/login" element={<LoginForm />} />

        <Route path="/membership-pricing" element={
          <PrivateRoute>
            <MembershipPricingPage />
          </PrivateRoute>
        } />

        <Route path="/profile/:id" element={
          <PrivateRoute >
            <ProfileDetailPage />
          </PrivateRoute>
        } />
        <Route path="/filter-maches" element={
          <PrivateRoute>
            <FilterPillBar />
          </PrivateRoute>} />

        <Route path="/matches-all--php-html" element={
          <PrivateRoute>
            <MatchesLayout />
          </PrivateRoute>} >
          <Route index element={<MatchesListPage />} />
          <Route path="ignored-by-you" element={<IgnoredProfilesListPage />} />
          <Route path="shorted-by-you" element={<FavouriteProfilesListPage />} />
          <Route path="interest" element={<InterestsProfilesListPage />} />
          <Route path="viewed-by-you" element={<ProfileViewsListPage />} />
          <Route path="newly-joined" element={<NewMatch30Days />} />
        </Route>
        <Route path="/profile-html-php" element={
          <PrivateRoute>
            <ProfileLayout />
          </PrivateRoute>
        }>
          <Route index element={<Userpage />} />
          <Route path="success-story" element={<SuccessStoriesPage />} />
          <Route path="upload-success-story" element={<SuccessStoryForm />} />
          <Route path="profile-update" element={<ProfileEditPage />} />
          <Route path="user-preference" element={<UserPreferences />} />
          <Route path="all-settings" element={<ProfileSettingsPage />} >
            <Route path="blocked-profile" element={<BlockProfilesListPage />} />
          </Route>
        </Route>
        <Route path="/verify-otp" element={<VerifyOTP />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/register-step2-html" element={<RegisterStep2 />} />
        <Route path="/register-step3-html" element={<RegisterStep3 />} />
        <Route path="/register-step4-html" element={<RegisterStep4 />} />
        <Route path="/register-step5-html" element={<RegisterStep5 />} />
        <Route path="/register-step6-html" element={<RegisterStep6 />} />
        {/* <Route path="/dashboard" element={<Dashboard />} /> */}


        {/* ✅ Admin – Direct Access */}
        {/* Admin */}

        <Route path="/admin-html-secure-metro/login" element={<AdminLoginForm />} />



        <Route

          path="/admin-html-secure-metro"

          element={

            <RequireAdminAuth>

              <AdminLayout />

            </RequireAdminAuth>

          }

        >
          <Route index element={<Dashboard />} />

          <Route path="dashboard" element={<Dashboard />} />

          <Route path="users" element={<UserTable />} />

          <Route path="blocked" element={<BlockedProfile />} />

          <Route path="plan" element={<MembershipPlan />} />

          <Route path="planform" element={<AddMembershipPlan />} />

          <Route path="purchase" element={<MembershipPurchase />} />

          <Route path="delete" element={<DeletedProfilesTable />} />

          <Route path="story" element={<SuccessStoryTable />} />

          <Route path="blogtable" element={<BlogTable />} />

          <Route path="blog" element={<UploadBlogForm />} />
          <Route path="popup" element={<PromoPopupManager />} />

          <Route path="contact" element={<ContactUsTable />} />

        </Route>



        {/* ✅ Admin – Direct Access */}

        <Route path="/admin-html-secure-metro" element={<AdminLayout />}>



        </Route>

      </Routes>
    </>
  );
}

export default App;
